export const IconInfo = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0006 3.25C6.27287 3.25 3.25092 6.27208 3.25092 10C3.25092 13.7279 6.27287 16.75 10.0006 16.75C13.7284 16.75 16.7504 13.7279 16.7504 10C16.7504 6.27208 13.7284 3.25 10.0006 3.25ZM1.75098 10C1.75098 5.44365 5.44448 1.75 10.0006 1.75C14.5568 1.75 18.2503 5.44365 18.2503 10C18.2503 14.5563 14.5568 18.25 10.0006 18.25C5.44448 18.25 1.75098 14.5563 1.75098 10Z"
      fill="#545454"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.6257 9.375C8.6257 8.96079 8.96147 8.625 9.37567 8.625H10.0007C10.1996 8.625 10.3904 8.70402 10.531 8.84467C10.6717 8.98533 10.7507 9.1761 10.7507 9.37501L10.7506 13.0104C11.1053 13.0699 11.3756 13.3784 11.3756 13.75C11.3756 14.1642 11.0398 14.5 10.6256 14.5H10.0006C9.80173 14.5 9.61097 14.421 9.47033 14.2803C9.32968 14.1397 9.25067 13.9489 9.25067 13.75L9.25074 10.1146C8.896 10.0552 8.6257 9.74665 8.6257 9.375Z"
      fill="#545454"
    />
    <path
      d="M9.8444 7.34375C10.2759 7.34375 10.6256 6.99397 10.6256 6.5625C10.6256 6.13103 10.2759 5.78125 9.8444 5.78125C9.41294 5.78125 9.06318 6.13103 9.06318 6.5625C9.06318 6.99397 9.41294 7.34375 9.8444 7.34375Z"
      fill="#545454"
    />
  </svg>
)
